import axios from "axios";
import { ordersServicesPath} from "../../../../Constants";

const typeJobRestUrl = ordersServicesPath + '/organizations/type-jobs'

export default class TypeJobService {

    static async getAllByOrganizationId() {
        return axios.get(typeJobRestUrl);
    }
}